import { ResetForm } from "@features/account-recovery";

export const ResetPage = () => <ResetForm />;
